export default __webpack_public_path__ + "static/media/our-services-17.619a9b28.png";